import React, {useState} from "react";
import { Box, Grid } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {Footer} from '../../components/footer';
import Question from "./Question";


const FAQ = () => {
    const {deviceType} = useSelector(state => state.configuration);
    const [selectedQuestion, setSelectedQuestion] = useState('none');
    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    return(
        <>
            <Box sx={{
                top: 0,
                margin: 0,
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh', // asegura que ocupe toda la altura de la ventana
                width: '100%',
                backgroundColor: '#313233',
                backgroundImage: "url('/assets/img/generic/fondo-black.svg')",
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}>
                <div className="animate pop delay-1" style={{
                    margin: 0,
                    padding: 0,
                    border: 0,
                    right:0,
                    // top:350,
                    width: '100%',
                    height: '850px',
                    display: deviceType==='minicell' || deviceType==='cell' ? 'none' : 'block',
                    position: 'absolute',
                    backgroundImage: "url('/assets/img/generic/ldtop.png')",
                    backgroundSize: '150px 550px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right',
                    zIndex: 0, 
                }}></div>
                <Box sx={{ flex: 1, }}>
                    <Grid container>
                        <Grid item size={12} sx={{
                            height:'100%',
                            width:'100%',
                            paddingTop:'80px',
                            marginBottom:'100px',
                        }}>
                            <Box 
                                // sx={{
                                //     background: 'linear-gradient(to top, transparent, #f2b85c, white, transparent)',
                                //     // backgroundImage:"url('/assets/img/generic/fondo2.png')",
                                // }}
                            >
                                <div style={{
                                    margin: 0,
                                    padding: 0,
                                    border: 0,
                                    width: '100%',
                                    height: '110px',
                                    display: 'block',
                                    position: 'absolute',
                                    backgroundImage: "url('/assets/img/generic/Roto2.svg')",
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'left',
                                    zIndex: 10,
                                    
                                }}></div>
                                <br /><br /><br /><br /><br /><br />
                                <Box className={deviceType==='minicell' || deviceType==='cell' ? 'text-title2 animate pop delay-1' : 'text-title animate pop delay-1'} 
                                    sx={{
                                        color:'white',
                                        width:'100%',
                                        // paddingLeft: '30px',
                                        // paddingBottom:' 0px',
                                        // fontSize:'30px',
                                        display:'flex',
                                        justifyContent:'center',
                                        textAlign:'center'
                                    }}>
                                        <div>{t("faq.title")}</div>
                                </Box>
                                
                            </Box>
                            <br /><br />
                            <Box className='animate pop delay-2'
                                sx={{
                                    color:'white',
                                    width:'100%',
                                    paddingLeft: deviceType==='minicell' || deviceType==='cell' ? '10px' : '80px',
                                    paddingRight: deviceType==='minicell' || deviceType==='cell' ? '10px' : '80px',
                                    zindex:4,
                                }}
                            >
                                <div style={{
                                    margin: 0,
                                    padding: 0,
                                    border: 0,
                                    left:0,
                                    // top:350,
                                    width: '100%',
                                    height: '100%',
                                    display: deviceType==='minicell' || deviceType==='cell' ? 'none' : 'block',
                                    position: 'absolute',
                                    backgroundImage: "url('/assets/img/generic/litop.png')",
                                    backgroundSize: '100px 350px',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'left',
                                    zIndex: 0,
                                }}></div>
                                <Question 
                                    question={t("faq.question1")}
                                    answer={t("faq.answer1")}
                                    selectedQuestion = {selectedQuestion}
                                    setSelectedQuestion = {setSelectedQuestion}
                                />
                                <Question 
                                    question={t("faq.question2")}
                                    answer={t("faq.answer2")}
                                    selectedQuestion = {selectedQuestion}
                                    setSelectedQuestion = {setSelectedQuestion}
                                />
                                <Question 
                                    question={t("faq.question3")}
                                    answer={t("faq.answer3")}
                                    selectedQuestion = {selectedQuestion}
                                    setSelectedQuestion = {setSelectedQuestion}
                                />
                                <Question 
                                    question={t("faq.question4")}
                                    answer={t("faq.answer4")}
                                    selectedQuestion = {selectedQuestion}
                                    setSelectedQuestion = {setSelectedQuestion}
                                />
                                <Question 
                                    question={t("faq.question5")}
                                    answer={t("faq.answer5")}
                                    selectedQuestion = {selectedQuestion}
                                    setSelectedQuestion = {setSelectedQuestion}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Footer />
            </Box>
        </>
    )
}

export default FAQ;